import { render, staticRenderFns } from "./WikidataSearch.vue?vue&type=template&id=2e448911&"
import script from "./WikidataSearch.vue?vue&type=script&lang=js&"
export * from "./WikidataSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports